import { getDomainOrigin, getHeaders } from 'utils/serverConfig';
import axios from 'axios';

export const sendCustomerPolicyCommunication = async (
    policyNumber: string
): Promise<Boolean> => {
    try {
        const { status } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/${policyNumber}/send-communication`,
            headers: getHeaders(),
        });

        if (status === 200) {
            return true;
        }

        return false;
    } catch (e) {
        return false;
    }
};
